import { useState, useEffect, useCallback } from 'react';
import { SessionStorageKey } from 'config';

export const useMainBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const isClosed = sessionStorage.getItem(SessionStorageKey.mainBannerClosed);
    setIsVisible(!isClosed);
  }, []);

  const closeBanner = useCallback(() => {
    sessionStorage.setItem(SessionStorageKey.mainBannerClosed, 'true');
    setIsVisible(false);
  }, []);

  return {
    isBannerVisible: isVisible,
    closeBanner,
  };
};
